import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export default (props) => {
	const [shouldShow, setShouldShow] = useState(false);
	const [showBannerPopup, setShowBannerPopup] = useState(false);
	const [showBannerTunePopup, setShowBannerTunePopup] = useState(true);

	return (
		<>
			<section id="header" className="d-flex align-items-sm-center">
				<div className="row text-white">
					<div className="col-12 col-sm-5 ml-sm-5 mt-5 mt-sm-0">
						<h1 className="text-center text-sm-start">LET PEACE OF MIND BE YOUR TRAVEL COMPANION</h1>
					</div>
				</div>
			</section>
			<section id="body">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="row shadow title mt-n5 position-relative justify-content-center">
								<div className="col-4 col-sm-5 align-self-center text-end py-3">
									<img src="../images/travel-icon.png" alt="Travel Insurance" width={120} />
								</div>
								<div className="col-8 col-sm-7 align-self-center text-start">
									<h1 className="my-5 mr-sm-5 text-white font-weight-bold">Travel Insurance</h1>
									
								</div>

								<div className="col-12 col-sm-4 align-self-center text-end">
									
								</div>

								<div className="col-12 col-sm-4 align-self-center text-end">
									
								</div>
								{/* <div className="col-12 col-sm-8 align-self-center text-center mb-3">
									<div style={{position: 'relative', display: 'inline-block'}}>
                                                <a href="../storage/pdf/Travel Insurance Campaign T&C 2026_RAYA TRIPS TNG TREATS_FINAL.pdf" target="_blank" class="btn text-white" style={{backgroundColor:'#173F35', borderColor: '#173F35'}}>
                                                	Raya Trips, TnG Treats Travel Insurance Campaign
                                                </a>
                                                <span style={{
                                                position: 'absolute',
                                                top: '-15px',
                                                right: '-10px',
                                                backgroundColor: '#E0EC89',
                                                color: '#173F35',
                                                fontSize: '12px',
                                                padding: '2px 6px',
                                                borderRadius: '5px',
                                                fontWeight: 'bold',
												}}>
                                                New
											    </span>
                                        </div>
								</div> */}
							</div>
							<div className="row content">
								<div className="col-1"></div>
								<div className="col-10 shadow bg-white rounded">
								
									<div className="row text-primary mt-4 px-sm-5 py-sm-3">
										<div className="col-12 mt-1 text-center">
											<p>
												Checkout our Travel Insurance before you go on holiday or even travel for business.
												Get yourself protected and be ready for the unexpected.
											</p>
											<p>
												<span className="font-italic font-weight-bold">COVID19 benefits</span> are now 
												available to cover the mandatory travel medical insurance required by your travel country.
											</p>
										</div>
									</div>
									<div className="row d-none d-sm-flex mb-4">
										<div className="col-12 pr-5  text-end">
											<small>* Terms and conditions apply.</small>
										</div>
									</div>
									<div className="row">
                                        <div className="col-12 text-center">
                                            <p className="pdpa small">
                                                By clicking 'Get Quote' button, you have read and agreed to our <a target="_blank" href={process.env.MIX_INSTAPOL_PRIVACY}>Privacy Policy</a>
                                            </p>
                                        </div>
                                    </div>
								</div>
								<div className="col-1"></div>
							</div>
							<div className="row footer text-center mt-n3">
								<div className="col-12">

								   {props.referral ?
									<a href={`/travel?r=${props.referral}`} className="btn btn-success">Get Quote</a>
								     :

									<a href="/travel" className="btn btn-success">Get Quote</a>
								   }

								</div>
							</div>

							<div className="row d-flex d-sm-none mt-3">
								<div className="col-12 text-center">
									<small>* Terms and conditions apply.</small>
								</div>
							</div>

							{/* <div className="row content mt-3">
								<div className="col-1 d-lg-block"></div>
								<div className="col-10 shadow bg-white rounded">
										<div className="col-12 mt-1 text-center">
											<p>
												<span className="font-weight-bold text-primary" style={{fontSize: "20px"}}>
													Raya Trips, TnG Treats Travel Insurance Campaign
												</span> 
								   				<br/>
												<span className="font-weight-bold text-primary">
													(19 March 2026 - 30 June 2026)
												</span> 
											</p>
										</div>		

										<div className="col-12 mt-1 px-sm-5">
											<small>
												Policyholders who purchase travel insurance via instaPol during the Campaign Period shall be entitled to receive Touch N' Go e-Wallet Credit which will be directly credited into the Touch N' Go eWallet associated with the mobile phone number provided to instaPol during the travel insurance purchase journey on instaPol.
											</small>
											
										</div>	

										<div className="row">
											<div className="col-1 d-none d-lg-block"></div>
											<div className="col-12 col-lg-10 mt-1">
											
												<table className='table table-bordered'>
													<thead>
														<tr>
															<th className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}} width={'40%'}>
																Product
															</th>
															<th className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}} width={'30%'}>
																Premium <br/>
																excluding SST and Stamp Duty

															</th>
															<th className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}} width={'30%'}>
																TNG  eWallet Credit
															</th>
														</tr>
														
													</thead>
													<tbody>
														<tr>
															<td  rowSpan={3} className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>Travel Insurance Single Trip</td>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>Below RM 100</td>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>RM 10</td>
														</tr>
														<tr>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>RM 100 - RM 199</td>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>RM 20</td>
														</tr>
														<tr>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>RM 200 and above</td>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>RM 30</td>
														</tr>
														<tr>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>Travel Insurance Annual Trip</td>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>RM 200 and above</td>
															<td className='text-center' style={{verticalAlign: "top", fontSize: "0.875em"}}>RM 50</td>
														</tr>
													</tbody>
												</table>
											
										</div>
										<div className="col-1 d-none d-lg-block"></div>

										</div>
										
										
										
								</div>
								<div className="col-1 d-lg-block"></div>
							</div> */}
						</div>
					</div>
				</div>
				<div className="row pds text-white mt-5">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p className="my-4 font-weight-bold">Please refer to the product disclosure sheet for more information on the benefits provided.</p>
                            </div>
                        </div>
                        <div className="row pds-row my-5 justify-content-center">


							{/* <div className="col-12 col-sm-3">
									
								<div className="pdf-icon">
									<img src="../images/msig.png" alt="MSIG Travel Insurance - Product Disclosure Sheet.pdf" className="img" width={80} />
								</div>
								<div>MSIG Travel Insurance</div>
								<a href="storage/pdf/PDS_msig.pdf" target="_blank" className="text-white text-decoration-none">
									<div>(Product Disclosure Sheet)</div>
								</a>
							</div>
							<div className="col-12 col-sm-3">
								<a href="storage/pdf/POLICY_WORDING_msig.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/msig.png" alt="MSIG Travel Insurance - Policy Wordings.pdf" className="img" width={80} />
                                    </div>
                                    <div>MSIG Travel Insurance</div>
				    				<div>(Policy Wording)</div>
                                </a>
                            </div> */}
              
							<div className="col-12 col-sm-3">
								<a href="storage/pdf/PDS_rhbi.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/rhbi.png" alt="RHBI Travel Insurance - Product Disclosure Sheet.pdf" className="img" width={80} />
                                    </div>
                                   <div> RHBI Travel Insurance</div>
				   					<div> (Product Disclosure Sheet)</div>
                                </a>
                            </div>
							<div className="col-12 col-sm-3">

								<a href="storage/pdf/POLICY_WORDING_rhbi.pdf" target="_blank" className="text-white text-decoration-none">
									<div className="pdf-icon">
										<img src="../images/rhbi.png" alt="RHBI - Master Policy Wordings (non-direct) (Final_11 Mar 2022).pdf" className="img" width={80} />
									</div>
									<div> RHBI Travel Insurance </div>
										
									<div>(Policy Wording)</div>
                                </a>
                            </div>

							

							<div className="col-12 col-sm-3">
								<a href="storage/pdf/Chubb Travel Insurance - Product Disclosure Sheet.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/chubb.png" alt="Chubb Travel Insurance - Product Disclosure Sheet.pdf" className="img" width={80} />
                                    </div>
                                   <div> Chubb Travel Insurance</div>
				   					<div> (Product Disclosure Sheet)</div>
                            	</a>
                            </div>
							<div className="col-12 col-sm-3">
								<a href="storage/pdf/Chubb Travel Insurance - Policy Wordings.pdf" target="_blank" className="text-white text-decoration-none">
										<div className="pdf-icon">
											<img src="../images/chubb.png" alt="Chubb Travel Insurance - Policy Wordings.pdf" className="img" width={80} />
										</div>
										<div> Chubb Travel Insurance </div>
									<div>(Policy Wording)</div>
								</a>
							</div>

							{/* <div className="col-12 col-sm-3">
								<a href="storage/pdf/AIG TRAVEL GUARD_PDS_INSTAPOL_23 FEB 2024.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/aig.png" alt="AIG TRAVEL GUARD_PDS_INSTAPOL_23 FEB 2024.pdf" className="img" width={80} />
                                    </div>
                                   <div> AIG Travel Insurance </div>
								<div>(Product Disclosure Sheet)</div>
                                </a>
                            </div>

							<div className="col-12 col-sm-3">
								<a href="storage/pdf/AIG Policy Wording.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/aig.png" alt="AIG Policy Wording.pdf" className="img" width={80} />
                                    </div>
                                   <div> AIG Travel Insurance </div>
				   					<div> (Policy Wording) </div>
                                </a>
                            </div> */}


							{/* <div className="d-none d-lg-block col-sm-3">
							
                            </div> */}

							<div className="col-12 col-sm-3">

							</div>

							<div className="col-12 col-sm-3">
								<a href="storage/pdf/Tune Travel Insurance - Product Disclosure Sheet.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/tune-logo.png" alt="Tune Travel Insurance - Product Disclosure Sheet.pdf" className="img-round" width={80} />
                                    </div>
                                    <div>Tune Travel Insurance</div>
				    				<div>(Product Disclosure Sheet)</div>
                                </a>
                            </div>
							<div className="col-12 col-sm-3">
								<a href="storage/pdf/Tune Travel Insurance - Policy Wordings.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/tune-logo.png" alt="Tune Travel Insurance - Policy Wordings.pdf" className="img-round" width={80} />
                                    </div>
                                    <div>Tune Travel Insurance</div>
				    				<div>(Policy Wording)</div>
                                </a>
                            </div>

							<div className="col-12 col-sm-3">
								
							</div>

							<div className="d-none d-lg-block col-sm-3">
								
                            </div>

							{/* For small screen */}	
							<div class="d-block d-lg-none">
								<div class="col-12">
								 <div>Underwritten by Tune Insurance Malaysia Berhad</div>
								 <div>Company No.: 197601004719 (30686-K)</div>
								</div>
							</div> 

				  			{/* For large screen    */}	
							<div class="d-none d-lg-block col-sm-1"></div>  
							<div class="d-none d-lg-block col-sm-6">
								<div>Underwritten by Tune Insurance Malaysia Berhad</div>
								<div>Company No.: 197601004719 (30686-K)</div>
							</div>
							<div class="d-none d-lg-block col-sm-1"></div>

							

							
	{/* <div className="col-12 col-sm-3">
								<a href="storage/pdf/Z-Takaful Product Disclosure Sheet.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/zurichtakaful.png" alt="Z-Takaful Product Disclosure Sheet.pdf" className="img" width={80} />
                                    </div>
                                    <div>Zurich Takaful Travel Insurance </div>
				    <div>(Product Disclosure Sheet)</div>
                                </a>
                            </div>
	<div className="col-12 col-sm-3">
								<a href="storage/pdf/Z-Takaful Policy Wordings.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                         <img src="../images/zurichtakaful.png" alt="Z-Takaful Policy Wordings.pdf" className="img" width={80} />
                                    </div>
                                    <div>Zurich Takaful Travel Insurance </div>
				    <div>(Policy Wording)</div>
                                </a>
                            </div> */}

                        </div>
                    </div>
                </div>
			</section>

			<PromptBanner show={showBannerPopup} onHide={() => setShowBannerPopup(false)} setShowBannerPopup={setShowBannerPopup} setShowBannerTunePopup={setShowBannerTunePopup} />
		    <PromptBannerTune show={showBannerTunePopup} onHide={() => setShowBannerTunePopup(false)} setShowBannerPopup={setShowBannerPopup} setShowBannerTunePopup={setShowBannerTunePopup}/>  		

			<Modal show={shouldShow} onHide={() => setShouldShow(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Reminder</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-12 text-center">
							<img src='../images/minimum-amount.png' className="img-fluid" width={330} />
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" size="sm" onClick={() => setShouldShow(false)}>OK</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

function PromptBanner(props) {

	function updateStatusRaya() {
		
		props.setShowBannerPopup(false);
		props.setShowBannerTunePopup(true);
	}

    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body style={{ padding: 0, position: 'relative' }}>
           <button
							type="button"
							className="banner-btn-close position-absolute"
			style={{
				width: '40px',
				height: '40px',
				borderRadius: '50%',
				backgroundColor: 'white',
				boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
				border: 'none',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				color: 'black', // Ensure icon inside is visible
				fontSize: '20px', // Adjust icon/text size
				fontWeight: 'bold',
				top: '10px',
				right: '10px',
				zIndex: '1',
			}}
							data-bs-dismiss="modal"
							aria-label="Close"
							//onClick={props.onHide} // Ensure this closes the modal
							onClick={(e) => updateStatusRaya(props)}
		><span aria-hidden="true">&times;</span></button>
           
		  {/* For small screen    */}
		  <img
					src={"../storage/image/Raya Travel Insurance Campaign SocMed.jpg"}
					alt="Full-Sized Image"
					className="img-fluid modal-image d-block d-lg-none"
					style={{ width: '100%', height: '100%', objectFit: 'cover' }}
				/>
           
		    {/* For Big screen */}
				<img
					src={"../storage/image/Raya Travel Insurance Campaign Carousel.png"}
					alt="Full-Sized Image"
					className="img-fluid modal-image d-none d-lg-block"
					style={{ width: '100%', height: '100%', objectFit: 'cover' }}
				/>
            
        </Modal.Body>
		<Modal.Footer style={{ padding: 0, position: 'relative' }}>
            <div style={{ width: '100%', height: '100%', textAlign: 'center', fontWeight: 'bold', cursor: 'pointer', color: '#9a5cd0'}} onClick={(e) => updateStatusRaya()}>
                Got It
            </div>
        </Modal.Footer>
    </Modal>
    
    );
}


function PromptBannerTune(props) {

	function updateStatus() {
		
		//props.setShowBannerPopup(false);
		props.setShowBannerTunePopup(false);
	}

    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body style={{ padding: 0, position: 'relative' }}>
           <button
							type="button"
							className="banner-btn-close position-absolute"
			style={{
				width: '40px',
				height: '40px',
				borderRadius: '50%',
				backgroundColor: 'white',
				boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
				border: 'none',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				color: 'black', // Ensure icon inside is visible
				fontSize: '20px', // Adjust icon/text size
				fontWeight: 'bold',
				top: '10px',
				right: '10px',
				zIndex: '1',
			}}
							data-bs-dismiss="modal"
							aria-label="Close"
							onClick={(e) => updateStatus()} // Ensure this closes the modal
		><span aria-hidden="true">&times;</span></button>

		  {/* For small screen    */}
		  <img
					src={"../storage/image/travel-tune-free-premium.png"}
					alt="Full-Sized Image"
					className="img-fluid modal-image d-block d-lg-none"
					style={{ width: '100%', height: '100%', objectFit: 'cover' }}
				/>
           
		    {/* For Big screen */}
				<img
					src={"../storage/image/travel-tune-free-premium.png"}
					alt="Full-Sized Image"
					className="img-fluid modal-image d-none d-lg-block"
					style={{ width: '100%', height: '100%', objectFit: 'cover' }}
				/>
            
        </Modal.Body>
		<Modal.Footer style={{ padding: 0, position: 'relative' }}>
            <div style={{ width: '100%', height: '100%', textAlign: 'center', fontWeight: 'bold', cursor: 'pointer', color: '#9a5cd0'}} onClick={(e) => updateStatus()}>
                Got It
            </div>
        </Modal.Footer>
    </Modal>
    
    );
}


